import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
    allFSIrons,
    fetchFSIrons,
    deleteFSIrons
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class fsirons extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            eid:'',
            clubform: [],
            cntclub:1,
            ballform: [],
            cntball:1,
            rateform: [],
            cntrate:1,
            smashform: [],
            cntsmash:1,            
            carryform: [],
            cntcry:1,
            aoaform: [],
            cntaoa:1,
            pathform: [],
            cntpath:1,
            hspform: [],
            cnthsp:1,
            ftpform: [],
            cntftp:1,
            fttform: [],
            cntftt:1,   
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

    UNSAFE_componentWillMount() {
	   this.props.allFSIrons();
	}


    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
      
    onBackSection() {
		this.setState({ 
         adddiv:false,
         viewdiv:true,
         editdiv:false,

       });
	}  


    editAssessment(gid){
        this.props.fetchFSIrons(gid).then((data) => {   
            var resdata=data.data;
            
            var allclub=resdata[0].gfs_clsp.split(",");
            var trclubobj=[]; 
            var trclubcnt=1;
            if(allclub.length!=0){
               {allclub.map((teamval) => (   
                  trclubobj.push({
                     club: teamval
                  })
               ))}
               trclubcnt=allclub.length;
            }else{
               trclubobj.push({
                  club: ''
               })
            }

            var allball=resdata[0].gfs_basp.split(",");
            var trballobj=[]; 
            var trballcnt=1;
            if(allball.length!=0){
               {allball.map((teamval) => (   
                  trballobj.push({
                     ball: teamval
                  })
               ))}
               trballcnt=allball.length;
            }else{
               trballobj.push({
                  ball: ''
               })
            }

            var allsmash=resdata[0].gfs_smash.split(",");
            var trsmashobj=[]; 
            var trsmashcnt=1;
            if(allsmash.length!=0){
               {allsmash.map((teamval) => (   
                  trsmashobj.push({
                     smash: teamval
                  })
               ))}
               trsmashcnt=allsmash.length;
            }else{
               trsmashobj.push({
                  smash: ''
               })
            }

            var allrate=resdata[0].gfs_sprt.split(",");
            var trrateobj=[]; 
            var trratecnt=1;
            if(allrate.length!=0){
               {allrate.map((teamval) => (   
                  trrateobj.push({
                     rate: teamval
                  })
               ))}
               trratecnt=allrate.length;
            }else{
               trrateobj.push({
                  rate: ''
               })
            } 
            
            var allcarry=resdata[0].gfs_carry.split(",");
            var trcryobj=[]; 
            var trcrycnt=1;
            if(allcarry.length!=0){
               {allcarry.map((teamval) => (   
                  trcryobj.push({
                     carry: teamval
                  })
               ))}
               trcrycnt=allcarry.length;
            }else{
               trcryobj.push({
                  carry: ''
               })
            }

            var allaoa=resdata[0].gfs_aoa.split(",");
            var traoaobj=[]; 
            var traoacnt=1;
            if(allaoa.length!=0){
               {allaoa.map((teamval) => (   
                  traoaobj.push({
                     aoa: teamval
                  })
               ))}
               traoacnt=allaoa.length;
            }else{
               traoaobj.push({
                  aoa: ''
               })
            }
            
            var allpath=resdata[0].gfs_path.split(",");
            var trpathobj=[]; 
            var trpathcnt=1;
            if(allpath.length!=0){
               {allpath.map((teamval) => (   
                  trpathobj.push({
                     path: teamval
                  })
               ))}
               trpathcnt=allpath.length;
            }else{
               trpathobj.push({
                  path: ''
               })
            }

            var allhsp=resdata[0].gfs_hsp.split(",");
            var trhspobj=[]; 
            var trhspcnt=1;
            if(allhsp.length!=0){
               {allhsp.map((teamval) => (   
                  trhspobj.push({
                     hsp: teamval
                  })
               ))}
               trhspcnt=allhsp.length;
            }else{
               trhspobj.push({
                  hsp: ''
               })
            }

            var allftp=resdata[0].gfs_ftp.split(",");
            var trftpobj=[]; 
            var trftpcnt=1;
            if(allftp.length!=0){
               {allftp.map((teamval) => (   
                  trftpobj.push({
                     ftp: teamval
                  })
               ))}
               trftpcnt=allftp.length;
            }else{
               trftpobj.push({
                  ftp: ''
               })
            }

            var allftt=resdata[0].gfs_ftt.split(",");
            var trfttobj=[]; 
            var trfttcnt=1;
            if(allftt.length!=0){
               {allftt.map((teamval) => (   
                  trfttobj.push({
                     ftt: teamval
                  })
               ))}
               trfttcnt=allftt.length;
            }else{
               trfttobj.push({
                  ftt: ''
               })
            }

            this.setState({ 
               seldate:resdata[0].gfs_date,  
               student:resdata[0].gfs_userID, 
               eid:resdata[0].gfsID,   
               carryform: trcryobj,
               cntcry:trcrycnt, 
               clubform: trclubobj,
               cntclub:trclubcnt,  
               ballform: trballobj,
               cntball:trballcnt,  
               rateform:trrateobj,
               cntrate:trratecnt,
               smashform:trsmashobj,
               cntsmash:trsmashcnt,
               aoaform:traoaobj,
               cntaoa:traoacnt,
               pathform:trpathobj,
               cntpath:trpathcnt,
               hspform:trhspobj,
               cnthsp:trhspcnt,
               ftpform:trftpobj,
               cntftp:trftpcnt,
               fttform:trfttobj,
               cntftt:trfttcnt,       
           });


            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteFSIrons(this.data);
            this.data = ""
        }
    }

    render() {
       const { match, fsironslist, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=fsironslist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gfsID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gfsID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                action: ebtn,
                action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Technique FS IRONS | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.fsirons" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add FS IRONS</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                 <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                 <UpdateItems onClick={this.onBackSection} data={this.state}/>   
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'FS Irons'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ fsirons }) => {
	const { fsironslist, loading } = fsirons;
	return { fsironslist, loading };
}

export default connect(mapStateToProps, {
    allFSIrons,
    fetchFSIrons,
    deleteFSIrons
})(fsirons); 